import { useMemo } from 'react';

import { Text } from 'ui';

const DonationCreditInfo = ({ credits }: { credits: string[] }) => {
  const creditInfo = useMemo(() => {
    if (credits.length === 0) return '';
    if (credits.length === 1) return credits[0];
    if (credits.length === 2) return `${credits[0]} & ${credits[1]}`;

    // ensure the use of Oxford comma and & before last credit
    const allButLastCredit = credits.slice(0, -1);
    const lastCredit = ` & ${credits[credits.length - 1]}`;
    allButLastCredit.push(lastCredit);

    return allButLastCredit.join(', ');
  }, [credits]);

  if (!creditInfo) return null;

  return (
    <Text type="caption" c="gray">
      {creditInfo} will be credited for this donation
    </Text>
  );
};

export { DonationCreditInfo };
